var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:border-r border-gray-200 bg-gray-800 z-30 overflow-y-auto"},[_c('div',{staticClass:"py-4 px-3"},[_c('sidebar-user-display'),(!_vm.$store.getters['authUser/isSupplier'])?_c('sidebar-links'):_vm._e(),(_vm.$store.getters['authUser/isSupplier'])?_c('sidebar-links-supplier',{staticClass:"mt-2"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }